const services = document.querySelectorAll(".infoimage-service__item");

const removeClassName = async () => {
  services.forEach((service) => {
    service.classList.remove("infoimage-service__item--active");
  });
};

const checkServices = () => {
  const activeServices = document.querySelectorAll(
    ".infoimage-service__item--active"
  );
  if (activeServices.length > 0) {
    services.forEach((service) => {
      service.classList.add("infoimage-service__item--inactive");
    });
  } else {
    services.forEach((service) => {
      service.classList.remove("infoimage-service__item--inactive");
    });
  }
};

services.forEach((service) => {
  service.addEventListener("click", async () => {
    if (!service.classList.contains("infoimage-service__item--active")) {
      await removeClassName();
    }
    service.classList.toggle("infoimage-service__item--active");

    checkServices();
  });
});
